import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Loader2 } from 'lucide-react';

interface Question {
  id: string;
  type: string;
  title: string;
  score: number;
}

interface SubjectiveTextAnswerAreaProps {
  question: Question;
  answer: string;
  isRevealed: boolean;
  aiExplanation?: string;
  onTextAnswerChange: (questionId: string, text: string) => void;
  onAIGrading: (question: Question) => void;
}

export default function SubjectiveTextAnswerArea({
  question,
  answer,
  isRevealed,
  aiExplanation,
  onTextAnswerChange,
  onAIGrading,
}: SubjectiveTextAnswerAreaProps) {
  return (
    <div className="space-y-4">
      {/* 文本输入区 */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-white rounded-xl border border-gray-200 overflow-hidden"
      >
        <div className="p-4">
          <textarea
            value={answer}
            onChange={(e) => onTextAnswerChange(question.id, e.target.value)}
            disabled={isRevealed}
            placeholder="请输入你的答案..."
            className={`w-full min-h-[200px] p-4 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-y ${
              isRevealed ? 'bg-gray-50 cursor-not-allowed' : ''
            }`}
          />
          
          {/* AI评分按钮 */}
          {!isRevealed && (
            <div className="mt-4 flex justify-end">
              <button
                onClick={() => onAIGrading(question)}
                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all shadow-md hover:shadow-lg"
              >
                <Sparkles className="w-4 h-4" />
                <span>AI智能评分</span>
              </button>
            </div>
          )}
        </div>
      </motion.div>

      {/* AI评分结果展示 */}
      {aiExplanation && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl border border-purple-200 overflow-hidden"
        >
          <div className="p-4">
            <div className="flex items-center gap-2 mb-3">
              <Sparkles className="w-5 h-5 text-purple-600" />
              <h4 className="font-medium text-purple-900">AI评分结果</h4>
            </div>
            <div className="text-sm text-gray-700 whitespace-pre-wrap">
              {aiExplanation}
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
}
